import React, { PureComponent } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { Input } from 'antd';

export interface TextArrayProps extends BaseInputProps {
  value?: string[];

  onChange?(val: string[]): void;
}

export class TextArray extends PureComponent<TextArrayProps> {
  value: string[] = [];

  isEmptyItem = (item: string) => {
    return !item.trim();
  };

  onChange = (i: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.trim();
    const value = [...this.value];
    value[i] = val;
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, '');
    this.props.onChange?.(value);
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
  };

  render() {
    this.value = this.props.value?.slice() || [];
    if (!this.value.length) this.value.push('');
    return (
      <div
        className={classNames(
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          <span>
            {this.value.filter(Boolean).join(', ') || '-'}
          </span>
        ) : (
          this.value.map((it, i) => (
            <div className='flex items-center pb-4 gap-8' key={i}>
              <Input
                type="text"
                placeholder=""
                value={it}
                onChange={this.onChange.bind(null, i)}
                onBlur={this.props.onBlur}
                autoComplete="off"
                style={{ width: 230 }}
              />
              <div className='col-span-2 flex space-x-2'>
                <PlusOutlined
                  onClick={this.onAdd.bind(null, i)}
                />
                <DeleteOutlined
                  onClick={this.onDel.bind(null, i)}
                />
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
}
